module.exports = __webpack_public_path__ + "img/app1.aa3b8388.png";